<script lang="ts">
	import Spinner from '$lib/components/atoms/spinner/Spinner.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		url: string;
	}

	const { url }: Props = $props();

	let loading = $state(true);
	let show = $state(false);

	function handleLoad() {
		loading = false;
		show = true;
	}
</script>

<div
	class="w-138 h-133 lt-sm-w-full lt-sm-h-full flex flex-col gap-2 bg-neutral-weakest justify-center"
>
	{#if loading}
		<div class="flex justify-center">
			<Spinner />
		</div>
	{/if}
	<iframe
		class={['size-full', show ? 'inline' : 'hidden']}
		title={m.modal__bookTheFork()}
		src={url}
		onload={handleLoad}
	></iframe>
</div>

<style>
	@media only screen and (min-width: 640px) {
		iframe {
			width: 553px;
			height: 530px;
		}
	}
</style>
